import Pagination from 'rc-pagination/lib/locale/zh_CN';
import SendCode from '../send-code/locale/zh_CN';

export default {
  locale: 'cn',
  Pagination,
  SendCode,
  global: {
    placeholder: '请选择',
  },
  FullScreen: {
    back: '切换全屏',
  },
};
